// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__NmLTm","index":"styles_index__JdriP"};